import { rerenderExoClickBeforePagination } from "@modules/azm/exoclick.ts" //TODO make Global?
import { dispatchGlobalEvent } from "@modules/util/events"
import { LogLevel, log } from "@modules/util/logger"
import { telephoneSexCardsContainerElement } from "../../global/dom.ts"
import { afterApiFetched } from "../after-api-fetched.ts"
import { fetchApi } from "../api.ts"
import {
    disableAllPaginationElements,
    getNextPage,
    getPage,
    getPreviousPageToLoad,
    setNextPage,
    setPage,
    setPreviousPage,
} from "../pagination/pagination"
import { rerenderSoladsBeforePagination } from "../solads"

export async function onPaginationButtonClick(element: HTMLElement | null, clickFunction: () => Promise<void>) {
    element?.setAttribute("loading", "")
    disableAllPaginationElements()
    try {
        await clickFunction()
    } catch (e: any) {
        log(LogLevel.ERROR, e)
    }

    element?.removeAttribute("loading")
}

export async function onPreviousClickPc() {
    setPage(getPage() - 1)
    await afterApiFetched(await fetchApi())
    rerenderSoladsBeforePagination()
    rerenderExoClickBeforePagination()

    dispatchGlobalEvent("telephonesex.pagination.change", {
        page: getPage(),
    })
}

export async function onPreviousClickMobile() {
    setPage(getPreviousPageToLoad())
    setPreviousPage(getPreviousPageToLoad() - 1)

    const firstCardElement = telephoneSexCardsContainerElement()?.querySelector(".ladies-card")
    await afterApiFetched(await fetchApi(), {
        insertAdjacentHTML: "afterbegin",
    })
    firstCardElement?.scrollIntoView()
    rerenderSoladsBeforePagination()
    rerenderExoClickBeforePagination()

    dispatchGlobalEvent("telephonesex.pagination.change", {
        page: getPage(),
    })
}

export async function onNextClickPc() {
    setPage(getPage() + 1)
    await afterApiFetched(await fetchApi())
    rerenderSoladsBeforePagination()
    rerenderExoClickBeforePagination()

    dispatchGlobalEvent("telephonesex.pagination.change", {
        page: getPage(),
    })
}

export async function onNextClickMobile() {
    setPage(getNextPage())
    setNextPage(getNextPage() + 1)

    await afterApiFetched(await fetchApi(), {
        insertAdjacentHTML: "beforeend",
    })
    rerenderSoladsBeforePagination()
    rerenderExoClickBeforePagination()

    dispatchGlobalEvent("telephonesex.pagination.change", {
        page: getPage(),
    })
}
